import Step4Icon from "images/Icons/CalendarL.inline.svg"
import Step4MobileIcon from "images/Icons/CalendarM.inline.svg"
import Step2Icon from "images/Icons/ClipboardOpenL.inline.svg"
import Step2MobileIcon from "images/Icons/ClipboardOpenM.inline.svg"
import Step3Icon from "images/Icons/GraphL.inline.svg"
import Step3MobileIcon from "images/Icons/GraphM.inline.svg"
import Step1Icon from "images/Icons/MessageL.inline.svg"
import Step1MobileIcon from "images/Icons/MessageM.inline.svg"
import Step5Icon from "images/Icons/StacksOpenL.inline.svg"
import Step5MobileIcon from "images/Icons/StacksOpenM.inline.svg"
import Step1IMG from "images/brokers/quoting/Step1.png"
import Step1MobileIMG from "images/brokers/quoting/Step1Mobile.png"
import Step2IMG from "images/brokers/quoting/Step2.png"
import Step2MobileIMG from "images/brokers/quoting/Step2Mobile.png"
import Step3IMG from "images/brokers/quoting/Step3.png"
import Step3MobileIMG from "images/brokers/quoting/Step3Mobile.png"
import Step4IMG from "images/brokers/quoting/Step4.png"
import Step4MobileIMG from "images/brokers/quoting/Step4Mobile.png"
import Step5IMG from "images/brokers/quoting/Step5.png"
import Step5MobileIMG from "images/brokers/quoting/Step5Mobile.png"

export const Steps = [
	{
		image: Step1IMG.src,
		mobileImage: Step1MobileIMG.src,
		icon: Step1Icon,
		mobileIcon: Step1MobileIcon,
		title: "Start Quoting",
		text: "Submit quotes through the Arlo Quoting Portal. Our tool helps you clean and standardize your submission in under 3 minutes.",
		alt: "A green interface for starting an automated insurance quote with input fields for group name, state, current date, effective date, and enrollment causes, showing submission time of 2 minutes and 14 seconds",
	},
	{
		image: Step2IMG.src,
		mobileImage: Step2MobileIMG.src,
		icon: Step2Icon,
		mobileIcon: Step2MobileIcon,
		title: "Review Proposal",
		text: "We return quotes within hours. You can view your quote submissions and proposals from right within your dashboard.",
		alt: 'A flowchart interface with two green panels showing "Quote Overview" with group information and "Key Features of Gold 1000" displaying Cigna and SmithRx network options, connected by lines to an "A" logo.',
	},
	{
		image: Step3IMG.src,
		mobileImage: Step3MobileIMG.src,
		icon: Step3Icon,
		mobileIcon: Step3MobileIcon,
		title: "Manage Implementation",
		text: "Closing a small group can be tricky and tedious. Our dashboard guides you through the process to make it as easy as possible.",
		alt: 'A vertical workflow showing three green panels connected by lines: "Provide Group Information" with a submitted status, "Submit the Medical Disclosure" with a signature, and "Upload Final Enrollment" with a document reference.',
	},
	{
		image: Step4IMG.src,
		mobileImage: Step4MobileIMG.src,
		icon: Step4Icon,
		mobileIcon: Step4MobileIcon,
		title: "Manage Groups During the Year",
		text: "Use our admin portal to stay on top of groups during the year. Easily manage enrollment changes, re-issue member ID cards, view EOB’s, and more.",
		alt: 'A healthcare plan interface showing "Plan Details: Arlo Gold 1000 Plan" panel with benefits information, alongside "Brynn Wells\' Member ID Card" and an "Explanation of Benefits" panel displaying coverage details.',
	},
	{
		image: Step5IMG.src,
		mobileImage: Step5MobileIMG.src,
		icon: Step5Icon,
		mobileIcon: Step5MobileIcon,
		title: "View Claims Performance",
		text: "Stay on top of the group’s claims performance by viewing claims, tracking spend categories, and finding opportunities to reduce costs.",
		alt: 'A claims management interface with two main sections - "View Claims" showing multiple claim numbers with statuses (submitted, accepted, in progress), and "Spend Categories" with a bar chart, plus a note indicating "24% decrease in specialty medications."',
	},
]

export default Steps
